const LOCATION_EVENT_NAME = 'location';
const ANONYMOUS_LOCATION_EVENT_NAME = 'anonymous_location';

export { LOCATION_EVENT_NAME, ANONYMOUS_LOCATION_EVENT_NAME };
